export * from './cookies';
export * from './defaultTranslations';
export * from './defaultTranslationsWithNamespaces';
export * from './style';

export const DATA_TEST_ID = 'data-testid';
